import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import voice_recode from "../assects/img/voice_recode.png"
import red_voice_recode from "../assects/img/Red_voice_recode.png"
import gray_voice_recode from "../assects/img/gray_voice_recode.png"

export interface VoiceRecorderHandle {
  stopRecording: () => void;
}

interface Props {
  onAudioRecorded: (audioBlob: Blob) => void;
  disabled?: boolean;
}

const VoiceRecorder2 = forwardRef<VoiceRecorderHandle, Props>(({ onAudioRecorded, disabled }, ref) => {
  const [recording, setRecording] = useState(false);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunks = useRef<Blob[]>([]);
  const streamRef = useRef<MediaStream | null>(null);

  const startRecording = async () => {
    if (disabled) return;

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;
    const mediaRecorder = new MediaRecorder(stream);
    mediaRecorderRef.current = mediaRecorder;
    audioChunks.current = [];

    mediaRecorder.ondataavailable = event => {
      if (event.data.size > 0) {
        audioChunks.current.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      const audioBlob = new Blob(audioChunks.current, { type: 'audio/webm' });
      onAudioRecorded(audioBlob);
      stream.getTracks().forEach(track => track.stop());
      setRecording(false);
    };

    mediaRecorder.start();

    setTimeout(() => {
      setRecording(true);
    }, 100); 
  };

  const stopRecording = () => {
    const recorder = mediaRecorderRef.current;
    if (recorder && recorder.state === 'recording') {
      recorder.stop();
    }
  };

  useImperativeHandle(ref, () => ({
    stopRecording
  }));

  return (
    <button
      onMouseDown={startRecording}
      onMouseUp={stopRecording}
      onTouchStart={startRecording}
      onTouchEnd={stopRecording}
      disabled={disabled}
      className={`lg:py-1 ps-2 rounded w-full h-full overflow-hidden text-white`}
    >
      {disabled ? <img src={gray_voice_recode} alt='mic' className="w-full h-full"/> : recording ? <img src={red_voice_recode} alt='mic' className="w-auto h-full"/> : <img src={voice_recode} alt='mic' className="w-auto h-full"/>}
    </button>
  );
});

export default VoiceRecorder2;
